import { useQuery } from "@tanstack/react-query";
import { getManagerTeam, getTeamTimesheets } from "../api/manager";

export function useManagerTeam(enabled = true) {
  return useQuery({
    queryKey: ["tawa", "manager", "team"],
    queryFn: getManagerTeam,
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function useTeamTimesheets(status?: string) {
  return useQuery({
    queryKey: ["tawa", "manager", "timesheets", status ?? null],
    queryFn: () => getTeamTimesheets(status),
    staleTime: 30_000,
  });
}
